interface FundInfoProps {
  strategy?: string;
  framework?: string;
  description?: string;
  fundSize?: string;
}

export function FundInfo({ strategy, framework, description, fundSize }: FundInfoProps) {
  return (
    <div className="space-y-6">
      {fundSize && (
        <div className="space-y-1.5">
          <p className="text-sm text-muted-foreground">Fund Size</p>
          <p className="font-medium break-words">{fundSize}</p>
        </div>
      )}

      <div className="space-y-1.5">
        <p className="text-sm text-muted-foreground">Strategy</p>
        <p className="font-medium break-words">{strategy || 'N/A'}</p>
      </div>

      <div className="space-y-1.5">
        <p className="text-sm text-muted-foreground">Framework</p>
        <p className="font-medium break-words">{framework || 'N/A'}</p>
      </div>

      {description && (
        <div className="space-y-1.5">
          <p className="text-sm text-muted-foreground">Description</p>
          <p className="text-sm break-words leading-relaxed">{description}</p>
        </div>
      )}
    </div>
  );
}